module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', {
    staticClass: "main-title latest-title grid-container"
  }, [_vm._v("Latest")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-navigation latest layer3"
  }), _vm._v(" "), _c('div', {
    staticClass: "social-latest grid-100 grid-parent layer1"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-50"
  }, [_c('div', {
    staticClass: "fb-box odd layer1"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "fb-post-paragraph",
    domProps: {
      "innerHTML": _vm._s(_vm.fbPosts[0].message)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.fbPosts[0].date))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.twPosts[0]) ? _c('div', {
    staticClass: "tw-box even grid-48"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[0].id_str
    }
  }, [_c('h4', [_vm._v("\n                        @Realrossnoble")])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.twPosts[0].text)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$parent.getDateInFormatTW(_vm.twPosts[0].created_at)))]), _vm._v(" "), _c('div', {
    staticClass: "social-icon"
  }, [(_vm.twPosts[0]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[0].id_str
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/twitter.png")
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.twPosts[1]) ? _c('div', {
    staticClass: "tw-box odd grid-48 margin-left-4"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[1].id_str
    }
  }, [_c('h4', [_vm._v("\n                        @Realrossnoble")])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.twPosts[1].text)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$parent.getDateInFormatTW(_vm.twPosts[1].created_at)))]), _vm._v(" "), _c('div', {
    staticClass: "social-icon"
  }, [(_vm.twPosts[1]) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/realrossnoble/status/' + _vm.twPosts[1].id_str
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/twitter_white.png")
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fb-box even"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "fb-post-paragraph",
    domProps: {
      "innerHTML": _vm._s(_vm.fbPosts[2].message)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.fbPosts[1].date))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "layer1",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/Ross.Noble/"
    }
  }, [_c('h4', [_vm._v("Ross.Noble")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-icon"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/Ross.Noble/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/facebook_white.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "layer1",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/Ross.Noble/"
    }
  }, [_c('h4', [_vm._v("Ross.Noble")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-icon"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/Ross.Noble/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/facebook.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-cta grid-100 grid-parent layer1"
  }, [_c('a', {
    staticClass: "layer1",
    attrs: {
      "href": "#/latest"
    }
  }, [_c('span', [_vm._v("More")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/arrow_home_cta.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea43e860","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Latest.vue
// module id = 290
// module chunks = 0